import "./PostItem.scss";
import comment from "../../assets/icons/comment.svg";
import {
  displayTime,
  computeTimeDifference,
  kFormatter,
} from "../../utils/helper";
import upvote from "../../assets/icons/upvote.svg";

const PostItem = ({ post, sr, keyword, i }) => {
  const {
    subreddit,
    author,
    num_comments,
    permalink,
    created_utc,
    title,
    thumbnail,
    score,
    selfText,
  } = post;

  let subredditImg = false;
  for (let i = 0; i < sr.length; i++) {
    if (sr[i].name === subreddit.toLowerCase()) {
      subredditImg = sr[i].icon;
    }
  }

  const content = selfText ? selfText : "";

  const date = displayTime(
    computeTimeDifference(Math.round(created_utc * 1000))
  );
  return (
    <a
      href={permalink}
      className="postItem__link"
      target="_blank"
      rel="noopener noreferrer"
    >
      <article
        className={`postItem ${i === 2 ? "postItem--reducedmargin" : ""}`}
      >
        <div className="postItem__container-top">
          <div className="postItem__wrapper">
            <div className="postItem__container">
              <img
                src={upvote}
                alt="upvote icon"
                className="postItem__arrow-img postItem__arrow-img--rotated"
              />
              <span className="postItem__score">{kFormatter(score)}</span>
              <img
                src={upvote}
                alt="downvote icon"
                className="postItem__arrow-img"
              />
            </div>
            {subredditImg ? (
              <img
                src={subredditImg}
                alt="subreddit icon"
                className="postItem__subreddit-img"
              />
            ) : (
              <div className="postItem__subreddit-placeholder"></div>
            )}
            <p className="postItem__subreddit">{`r/${subreddit}`}</p>{" "}
          </div>
          <p className="postItem__metadata">{`• Posted by u/${author} ${date}`}</p>
        </div>
        <h3 className="postItem__title">
          {title.split(" ").map((word, i) => {
            if (word.toLowerCase() === keyword)
              return (
                <span className="postItem__title--highlight" key={i}>
                  {word + " "}
                </span>
              );
            return word + " ";
          })}
        </h3>
        <p className="postItem__content">
          {thumbnail ? (
            <img
              src={thumbnail}
              className="postItem__content-img"
              alt="thumbnail"
            />
          ) : (
            content
          )}
        </p>
        <div className="postItem__container-bottom">
          <img
            src={comment}
            alt="comment icon"
            className="postItem__comment-img"
          />{" "}
          <span className="postItem__comments">{`${num_comments} comments`}</span>
        </div>
      </article>
    </a>
  );
};

export default PostItem;
